import React, { useState }      from 'react';
import SendIcon                 from '@mui/icons-material/Send';
import CloseIcon                from '@mui/icons-material/Close';
import SendEmail                from '../SendEmail';
import { useTranslation }       from 'react-i18next';

import { 
    Modal, 
    Box, 
    TextField, 
    Button, 
    Typography, 
    IconButton,
    Snackbar,
    Alert
} from '@mui/material';
import SendAvviso from '../SendAvviso';


const MerceNonConformeEditModal = ({ open, onClose, selectedRMA }) => {
    const { t } = useTranslation();

    const [messaggio,           setMessaggio        ] = useState('');
    const [destinatari,         setDestinatari      ] = useState('');
    const [messageSnackbar,     setMessageSnackbar  ] = useState('');
    const [openSnackbar,        setOpenSnackbar     ] = useState(false);
    const [snackbarSeverity,    setSnackbarSeverity ] = useState('success');  
    const [errorDestinatari,    setErrorDestinatari ] = useState(false); 

    const validateEmails = (emailsString) => {
        const emailArray = emailsString.split(";").map(email => email.trim());
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
        return emailArray.every(email => emailRegex.test(email)); 
    };

    const handleDestinatariChange = (e) => {
        const value = e.target.value;
        setDestinatari(value);
    
        if (!validateEmails(value)) {
            setErrorDestinatari(true);
        } else {
            setErrorDestinatari(false);
        }
    };
    


    const handleSend = () => {
        const destinatario      = selectedRMA?.cliente?.emailPersonaContatto;
        const idReso            = selectedRMA?.idReso;
        const idDestinatario    = selectedRMA?.cliente?.id;

        // SendEmail(
        //     idReso,
        //     destinatario,
        //     messaggio,
        //     "EMAIL_MERCENONCONFORME",
        //     () => {
        //         setMessageSnackbar(t('Email inviata con successo!'));
        //         setSnackbarSeverity('success');
        //         setOpenSnackbar(true);
        //     },
        //     () => {
        //         setMessageSnackbar(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //         setOpenSnackbar(true);
        //     }
        // )

        SendAvviso(
            idReso,
            idDestinatario,
            'AVVISO_MERCENONCONFORME',
            () => {
                setMessageSnackbar(t('Avviso inviato con successo! vi contatteremo al più presto!'));
                setSnackbarSeverity('success');
                setOpenSnackbar(true);
            },
            () => {
                setMessageSnackbar(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
            }
        );
        setMessaggio('');
        onClose();
    };


    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <>
        <Modal open={open} onClose={onClose}
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            width: '70%',
            height: '50%',
            m: 'auto'
        }}>
            <Box
                sx={{
                    width: '70%',
                    height: 'auto',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    border: 'solid 2px #bdbdbd'
                }}
            >
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
                >
                <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: '#FDA03D' }}>
                    {t('Scrivi un messaggio a {{ragioneSociale}} per RMA #{{idReso}}', {
                        ragioneSociale: selectedRMA?.cliente?.ragioneSociale,
                        idReso: selectedRMA?.idReso
                    })}
                </Typography>

                <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    '&:hover': {
                        color: 'red',
                        transform: 'scale(1.01)',
                        bgcolor: 'transparent'
                    }
                }}>
                    <CloseIcon />
                </IconButton>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 4}}>
                <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Destinatari (es: user1@dominio.com; user2@dominio.com)"
                    value={destinatari}
                    onChange={handleDestinatariChange}
                    error={errorDestinatari}
                    helperText={
                        errorDestinatari
                        ? "Inserisci email valide separate da ';'."
                        : ""
                    }
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                                borderColor: '#25375d',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#25375d',
                            },
                        },
                    }}
                />
                <TextField
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    placeholder="Scrivi il tuo messaggio qui..."
                    value={messaggio}
                    onChange={(e) => setMessaggio(e.target.value)}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                                borderColor: '#25375d',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#25375d',
                            },
                        },
                    }}
                />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleSend}
                        endIcon={<SendIcon sx={{ ml: 1}} />}
                        sx={{
                            mt: 4,
                            borderRadius: '10px',
                            width: '10em',
                            backgroundColor: "#213d72", 
                            color: "#ffffff", 
                            "&:hover": {
                                backgroundColor: "#1a315b", 
                                transform: "scale(1.05)",
                            },
                        }}
                        autoFocus
                    >
                        Invia
                    </Button>
                </Box>
            </Box>
        </Modal>
        <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {messageSnackbar}
        </Alert>
        </Snackbar>
    </>
    );
};

export default MerceNonConformeEditModal;
